import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import { SidebarNav } from './components';
import {ThemeModeToggler} from "../index";
import AccountMenu from '../../../../containers/Navbar/AccountMenu'
import {useSelector} from 'react-redux'
import {isLoaded, isEmpty} from 'react-redux-firebase'
import Link2 from "@mui/material/Link";

function Greeting(props) {
    const isLoggedIn = props.isLoggedIn;
    if (isLoggedIn) {
        return <AccountMenu/>
    }
    return <Fragment/>
}

const Sidebar = ({ pages, open, variant, onClose }) => {
    const auth = useSelector(state => state.firebase.auth)
    const authExists = isLoaded(auth) && !isEmpty(auth)


  return (
    <Drawer
      anchor="left"
      onClose={() => onClose()}
      open={open}
      variant={variant}
      sx={{
        '& .MuiPaper-root': {
          width: '100%',
          maxWidth: 280,
        },
      }}
    >
      <Box
        sx={{
          height: '100%',
          padding: 1,
        }}
      >
        <SidebarNav pages={pages} />

          <Box marginLeft={14}>

              <ThemeModeToggler />

          </Box>

          <br/>

          <Box marginLeft={14}>
              <Greeting isLoggedIn={authExists} />

          </Box>


      </Box>

    </Drawer>
  );
};

Sidebar.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired,
  pages: PropTypes.object.isRequired,
};

export default Sidebar;
